import { createSlice } from "@reduxjs/toolkit";

const localTaskForceRoleSlice = createSlice({
  name: "localTaskForceRoles",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchLocalTaskForceRolesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLocalTaskForceRolesSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchLocalTaskForceRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLocalTaskForceRolesRequest,
  fetchLocalTaskForceRolesSuccess,
  fetchLocalTaskForceRolesFailure,
} = localTaskForceRoleSlice.actions;

export default localTaskForceRoleSlice.reducer;